"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ItemConditions;
(function (ItemConditions) {
    ItemConditions["DamagedCondition"] = "https://schema.org/DamagedCondition";
    ItemConditions["NewCondition"] = "https://schema.org/NewCondition";
    ItemConditions["RefurbishedCondition"] = "https://schema.org/RefurbishedCondition";
    ItemConditions["UsedCondition"] = "https://schema.org/UsedCondition";
})(ItemConditions = exports.ItemConditions || (exports.ItemConditions = {}));
var ItemAvailability;
(function (ItemAvailability) {
    ItemAvailability["Discounted"] = "https://schema.org/Discontinued";
    ItemAvailability["InStock"] = "https://schema.org/InStock";
    ItemAvailability["InStoryOnly"] = "https://schema.org/InStoreOnly";
    ItemAvailability["LimitedAvailability"] = "https://schema.org/LimitedAvailability";
    ItemAvailability["OnlineOnly"] = "https://schema.org/OnlineOnly";
    ItemAvailability["OutOfStock"] = "https://schema.org/OutOfStock";
    ItemAvailability["PreOrder"] = "https://schema.org/PreOrder";
    ItemAvailability["PreSale"] = "https://schema.org/PreSale";
    ItemAvailability["SoldOut"] = "https://schema.org/SoldOut";
    ItemAvailability["BackOrder"] = "https://schema.org/BackOrder";
})(ItemAvailability = exports.ItemAvailability || (exports.ItemAvailability = {}));
